import { Component, Input } from '@angular/core';
import { LoaderComponent, LoaderSize, LoaderThemeColor, LoaderType } from '@progress/kendo-angular-indicators';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'CDMS-common-load-indicator-control',
  templateUrl: './common-load-indicator-control.component.html',
  styleUrls: ['../assets/scss/_common-components.scss'],
  imports: [LoaderComponent],
})
export class CommonLoadIndicatorControl {
  @Input() show = false;
  @Input() type: LoaderType = 'infinite-spinner';
  @Input() size: LoaderSize = 'large';
  @Input() themeColor: LoaderThemeColor = 'primary';

  constructor() {}
}
